import { registerHandlerOnSagaError } from '../saga-error-handler';

import { globalErrorHandler } from './register-error-handlers';

export const registerSagaErrorHandler = () => registerHandlerOnSagaError(globalErrorHandler);
